<!--
 * @Description: 注册页面
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-04 09:11:41
 * @LastEditTime: 2019-07-26 18:24:40
 -->
<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane label="注册" name="first">
        <el-form ref="form" :rules="form.rules" :model="form.data">
          <el-form-item prop="userType">
            <el-radio v-model="form.data.userType" label="1">货源方</el-radio>
            <el-radio v-model="form.data.userType" label="2">运力方</el-radio>
            <el-radio v-model="form.data.userType" label="4">仓储方供给</el-radio>
            <el-radio v-model="form.data.userType" label="3">仓储方需求</el-radio>
          </el-form-item>
          <el-form-item prop="phone">
            <el-input v-model="form.data.phone" class="reg-must" placeholder="请输入手机号" @keyup.enter.native="regFn" />
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="form.data.password" class="reg-must" type="password" placeholder="请输入密码（推荐使用数字、字母、特殊符号组合密码6-20位）" autocomplete="off" @keyup.enter.native="regFn" />
          </el-form-item>
          <el-form-item prop="checkPass">
            <el-input v-model="form.data.checkPass" class="reg-must" type="password" placeholder="请再次输入您刚设置的密码" autocomplete="off" @keyup.enter.native="regFn" />
          </el-form-item>
          <!-- 手机验证码 -->
          <el-form-item prop="code">
            <el-row>
              <el-col :span="15">
                <el-input v-model="form.data.code" class="reg-must" placeholder="请输入验证码" @keyup.enter.native="regFn" />
              </el-col>
              <el-col :push="1" :span="8">
                <el-button class="code-btn" :disabled="phoneCode.disabled" @click="getPhoneCode">{{ phoneCode.sendCodeText }}{{ typeof phoneCode.sendCodeText === 'number' ? 's' : '' }}</el-button>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item>
            <el-button class="button" @click="regFn">注册</el-button>
          </el-form-item>
        </el-form>
        <div class="bottom">
          <router-link class="login-reg-link" :to="{name: 'Login'}">登录</router-link>
        </div>
      </el-tab-pane>
    </el-tabs>
    <!-- 平台协议 -->
    <el-dialog :visible.sync="platform" width="800px" title="注册协议">
      <el-form ref="offerForm">
        <div class="con" v-html="platformTxt">
          <!--<p class="con-title">平台报价规则如下：</p>-->
          <!--<div class="con-box">-->
          <!--<p>1.权利人的姓名(名称)、联系方式、地址、身份证扫揎件(自然人)、企业法人营业执照(单位)、法定代表人身份证明(单位</p>-->
          <!--<p>2.要求删除或者断开链接的侵权作品的淮确名称和网络地址,以便干图网能够发现并初步审核涉嫌侵权作品。</p>-->
          <!--<p>3.认为构成侵权的初步证明材料,包括但不限于对作品享有版权或依法享有信息网络传播权的权属证明,以及涉嫌侵权作品侵权事实的举证。</p>-->
          <!--<p>4.通知书需由权利人或其合法授权人亲笔签名,若为单位则需加盖单位公章</p>-->
          <!--</div>-->
        </div>
        <el-checkbox v-model="checkedRule">我同意以上规则</el-checkbox>
        <el-checkbox v-model="checkedRemind">以后不再提醒</el-checkbox>
        <!--<el-checkbox v-model="checkedRule"></el-checkbox>-->
        <div class="form-line">
          <el-form-item>
            <el-button class="quotation-form-btn quotation-btn" :class="{'quotation-btn-xz': !checkedRule}" @click="nexStep">下一步</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import { encryption, CountDown } from '@/utils/common'
import { getPhoneCode } from '@/api/common'
// import { checkStrong } from '@/utils/checkpassStrong.js'
import { reg, getPhoneIf, findCmsPlatformProtocol, upateStatus } from '@/api/user'

export default {
  name: 'Reg',
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.data.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    const checkingRepeat = (rule, value, callback) => {
      const reg = /^(.)\1{5}/
      const tmp = reg.test(value)
      if (tmp) {
        callback(new Error('不可六位及以上的连续字符'))
      } else {
        callback()
      }
    }

    const checkUserEqualPwd = (rule, value, callback) => {
      if (value == this.form.data.phone) {
        callback(new Error('设置的密码不能与注册的手机号相同!'))
      } else {
        callback()
      }
    }
    const checking = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('手机号不可为空'))
      } else {
        getPhoneIf({
          phone: value
        }).then(res => {
          console.log(res)
          if (res.message == '手机号已经存在') {
            callback(new Error('手机号已经存在'))
          } else {
            callback()
          }
        }).catch(error => {
          console.log(error)
        })
      }
    }

    return {
      // 平台规则弹窗状态
      platform: false,
      // 是否同意规则
      checkedRule: false,
      // 是否不再提示平台规则
      checkedRemind: false,
      platformTxt: '',
      activeName: 'first',
      // 验证码
      phoneCode: {
        sendCodeText: '发送验证码',
        disabled: false,
        timer: null
      },
      // 表单相关
      form: {
        data: {
          userType: '1',
          phone: '',
          password: '',
          checkPass: '',
          code: ''
        },
        rules: {
          phone: [
            { validator: this.$validate('phone'), required: true },
            { trigger: 'blur', validator: checking }
          ],
          password: [
            { validator: this.$validate('password'), required: true },
            { validator: checkUserEqualPwd, trigger: 'blur' },
            { validator: checkingRepeat, trigger: 'blur' }
          ],
          checkPass: [{ validator: validatePass, trigger: 'blur' }],
          code: [
            // /([a-z0-9\.\@\!\#\$\%\^\&\*\(\)])\1{2}/
            { required: true, message: '请输入验证码', trigger: 'blur' },
            { validator: this.$validate('code'), required: true }]
        }
      },
      regIf: true
    }
  },
  beforeDestroy() {
    // 卸载组件前关闭定时器
    clearInterval(this.phoneCode.timer)
  },
  methods: {
    // 注册
    regFn() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (this.regIf) {
            const con = {
              type: 1,
              location: 1
            }
            findCmsPlatformProtocol(con).then(res => {
              console.log(res)
              if (res.result.length < 1 || this.checkedRemind == true) {
                this.regIf = false
                console.log('通过')
                const formData = JSON.parse(JSON.stringify(this.form.data))
                delete formData.checkPass // 删除确认密码字段
                // formData.password = encryption({ 'key': 'thanks,pig4cloud', 'value': formData.password }) // 前端密码加密
                reg({
                  methodName: 'regSysUser',
                  phone: formData.phone,
                  password: formData.password,
                  code: formData.code,
                  userType: formData.userType
                  // pwdLevel: checkStrong(formData.password)
                }).then(res => {
                  this.regIf = true
                  this.$confirm('注册成功是否去登陆？').then(() => {
                    this.$router.push({
                      name: 'Login'
                    })
                  })
                })
              } else {
                this.platform = true
                this.platformTxt = res.result[0].content
              }
            })
          }
        }
      })
    },
    // 平台协议下一步
    nexStep(data) {
      if (this.checkedRule) {
        let showIf = false
        if (this.checkedRule == true) {
          showIf = 0
        } else {
          showIf = 1
        }
        const con = {
          type: 1,
          location: 1,
          status: showIf
        }
        this.platform = false
        upateStatus(con).then(res => {
          console.log(res)
          this.regFn(true)
        })
      } else {
        this.$message({
          message: '未同意以上规则！',
          type: 'warning'
        })
      }
    },
    // 设置定时器
    setTimer() {
      const phoneCode = this.phoneCode
      phoneCode.disabled = true
      // 倒计时时间
      phoneCode.sendCodeText = CountDown
      phoneCode.timer = setInterval(() => {
        if (phoneCode.sendCodeText <= 1) {
          phoneCode.sendCodeText = '重新获取'
          // 关闭并清空定时器
          clearInterval(phoneCode.timer)
          phoneCode.timer = null
          phoneCode.disabled = false
        } else {
          phoneCode.sendCodeText--
        }
      }, 1000)
    },
    // 获取手机验证码
    getPhoneCode() {
      this.$refs.form.validateField('phone', (valid, str) => {
        if (!valid) { // 验证成功返回null
          this.setTimer()
          getPhoneCode({ phone: this.form.data.phone })
            .then(res => {
              this.$message({
                message: '验证码已发送',
                type: 'success',
                offset: 100
              })
              // 由于方便测试每次从后台获取验证码自动填入表单
              // this.form.data.code = res.result
            }, () => {
              this.clearTimer('发送验证码')
            })
        }
      })
    }
  }
}
</script>

<style scoped lang='scss'>
// 居中元素
/deep/.el-tabs__nav-scroll{
  display: flex;
  justify-content: center;
}
// 隐藏选中下边框
/deep/.el-tabs__active-bar{
  display: none;
}
/deep/.el-tabs__content{
  overflow: unset;
}
// .el-button:focus, .el-button:hover{
//   color: $base-color;
// }
// 修改全局边框颜色
.el-button{
  border-color: $base-color;
}
.el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover{
  border-color: $base-color;
}
.bottom{
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
  .reg-must{
    position: relative;
  }
  .reg-must:before{
    content: '*';
    position: absolute;
    color: red;
    left: -13px;
    top: 21px;
  }
.con{
  position: relative;
  margin-bottom: 10px;
  margin-top: 10px;
  padding: 5px 0px;
  padding-bottom: 15px;
  border-bottom: 1px solid #E3E3E3;
  .con-title{
    padding-bottom: 10px;
    color: #F92929;
  }
  .con-box{
    p{
      padding-bottom: 8px;
      line-height: 18px;
    }
  }
}
.quotation-btn{
  margin: 0 auto;
  display: block;
  margin-top: 20px;
  border-radius: 5px;
  background: #BF2317;
  color: #fff;
  &.quotation-btn-xz{
    background: #DE9189;
    color: #F2CCC3;
  }
}
</style>
